"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localeToLang = void 0;
var supportedLanguageCodes = ['bg', 'cs', 'da', 'de', 'el', 'en', 'es', 'et', 'fi', 'fr', 'hr', 'hu', 'it', 'lt', 'lv', 'nb', 'nl', 'pl', 'pt', 'ro', 'sk', 'sv', 'sl'];
var localeToLang = function localeToLang(locale) {
  var localeFromParamOrBrowser = locale ? locale : navigator.language;
  var localeArray = localeFromParamOrBrowser.split('-');
  if (localeArray.length < 1) {
    return 'en';
  }
  var languageCode = supportedLanguageCodes.find(function (country) {
    return country === localeArray[0];
  });
  return languageCode ? languageCode : 'en';
};
exports.localeToLang = localeToLang;